import { Column } from "../objects/column";

export function moveColumn(columns: Column[], index: number, swapColumnIndex: number): Column[] {
    const result = columns.map((column) => ({
        ...column,
        last_updated: false
    }));
    const currentColumn = result[index];
    return result.map((column, columnIndex) => {
        const nextColumn = result[swapColumnIndex];
        if (columnIndex === index && nextColumn) {
            return nextColumn;
        } else if (columnIndex === swapColumnIndex && currentColumn) {
            return {...currentColumn, last_updated: true};
        }
        return column;
    });
}